import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, of, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        // Default navigation
        const defaultNavigation: Navigation = {
            compact   : [],
            default   : [
                {
                    id   : 'dashboard',
                    title: 'Dashboard',
                    type : 'basic',
                    icon : 'heroicons_outline:home',
                    link : '/dashboard'
                }
            ],
            futuristic: [],
            horizontal: [
                {
                    id   : 'dashboard',
                    title: 'Dashboard',
                    type : 'basic',
                    icon : 'heroicons_outline:home',
                    link : '/dashboard'
                }
            ]
        };

        this._navigation.next(defaultNavigation);
        return of(defaultNavigation);
    }
}
